import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate' // 数据持久化

const store = createPinia()
store.use(
  createPersistedState({
    storage: {
      getItem: uni.getStorageSync,
      setItem: uni.setStorageSync,
    },
  }),
)

export default store

// 模块统一导出

export * from './adminPlayerProjectConf'
export * from './appSetting'
export * from './cashier'
export * from './clubConfig'
export * from './homeBanner'
export * from './leagueWithdrawal'
export * from './memberModules'
export * from './penalty'
export * from './permission'
export * from './playerOnlineStatus'
export * from './playerProjectConf'
export * from './receptionOrder'
export * from './transactionHistory'
export * from './transmitUserInfo'
export * from './user'
export * from './userTypePopup'
